import cn from './cn';

export type { ClassValue } from './cn';
export default cn;
